import POST_COMPONENT_TYPE from '../postComponentType';
import LealyHero from '../../../assets/images/lealy-hero-section.png';
import { IconType } from '../../../components/BannerWithList';
import { BackgroundColor } from '../../../components/BannerWithTextAndDescription';
import { TextBoxBackgroundColor } from '../../../components/BannerWithTextBox';

const lealy = {
  key: 'lealy',
  sectionList: [
    {
      type: POST_COMPONENT_TYPE.title,
      text: 'learnMoreContent.lealy.name'
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextBox,
      image: LealyHero,
      text: 'learnMoreContent.lealy.banner.text',
      backgroundColor: TextBoxBackgroundColor.GREEN
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.lealy.reasons.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.lealy.reasons.listItem1',
              type: 'text'
            },
            {
              text: 'learnMoreContent.lealy.reasons.listItem2',
              type: 'text'
            },
            {
              text: 'learnMoreContent.lealy.reasons.listItem3',
              type: 'text'
            },
            {
              text: 'learnMoreContent.lealy.reasons.listItem4',
              type: 'text'
            },
            {
              text: 'learnMoreContent.lealy.reasons.listItem5',
              type: 'text'
            },
            {
              text: 'learnMoreContent.lealy.reasons.listItem6',
              type: 'text'
            }
          ]
        }
      ]
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.lealy.howItWorks.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.lealy.howItWorks.listItem1',
              type: 'text'
            },
            {
              text: 'learnMoreContent.lealy.howItWorks.listItem2',
              type: 'text',
              subItems: [
                {
                  text: 'learnMoreContent.lealy.howItWorks.listItem2.subItem1',
                  type: 'text'
                },
                {
                  text: 'learnMoreContent.lealy.howItWorks.listItem2.subItem2',
                  type: 'text'
                },
                {
                  text: 'learnMoreContent.lealy.howItWorks.listItem2.subItem3',
                  type: 'text'
                },
                {
                  text: 'learnMoreContent.lealy.howItWorks.listItem2.subItem4',
                  type: 'text'
                }
              ]
            },
            {
              text: 'learnMoreContent.lealy.howItWorks.listItem3',
              type: 'text'
            },
            {
              text: 'learnMoreContent.lealy.howItWorks.listItem4',
              type: 'text'
            }
          ]
        }
      ]
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextAndDescription,
      title: 'learnMoreContent.lealy.expectations.title',
      backgroundColor: BackgroundColor.GREEN,
      description: {
        text: 'learnMoreContent.lealy.expectations.description',
        type: 'text'
      }
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.lealy.noExpectations.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.lealy.noExpectations.listItem1',
              type: 'text'
            },
            {
              text: 'learnMoreContent.lealy.noExpectations.listItem2',
              type: 'text'
            },
            {
              text: 'learnMoreContent.lealy.noExpectations.listItem3',
              type: 'text'
            }
          ]
        }
      ]
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.lealy.getStarted.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          title: 'learnMoreContent.lealy.getStarted.listGroup1.title',
          items: [
            {
              text: 'learnMoreContent.lealy.getStarted.listGroup1.listItem1',
              type: 'textWithLink',
              linkText:
                'learnMoreContent.lealy.getStarted.listGroup1.bookLinkText',
              link:
                'https://www.lealy.health/lealy-ursachenanalyse-buchen?utm_source=health-yourself'
            },
            {
              text: 'learnMoreContent.lealy.getStarted.listGroup1.listItem2',
              type: 'textWithLink',
              linkText:
                'learnMoreContent.lealy.getStarted.listGroup1.webinarLinkText',
              link:
                'https://www.lealy.health/webinar?utm_source=health-yourself'
            },
            {
              text: 'learnMoreContent.lealy.getStarted.listGroup1.listItem3',
              type: 'textWithLink',
              linkText:
                'learnMoreContent.lealy.getStarted.listGroup1.newsletterLinkText',
              link:
                'https://www.lealy.health/newsletter?utm_source=health-yourself'
            }
          ]
        }
      ]
    }
  ]
};

export default lealy;